@if (formGroup) {
    <form [formGroup]="formGroup" (ngSubmit)="save()">
        <div class="row top-row">
            <div class="col-md-5 header mb-xl-4 mb-lg-4 mb-md-4">
                <div class="header-title">
                    <h3 class="main-title">{{ 'bop.buttons.create-bop' | translate }}</h3>
                    <p class="description">{{ 'shared.miscellaneous.user-change-values' | translate }}</p>
                </div>
            </div>
            <div class="col-md-7 my-2 mb-2 mb-sm-3">
                <div class="d-flex flex-wrap justify-content-start justify-content-sm-end gap-10">
                    <ceres-button icon="check-mark" type="submit">{{ 'shared.buttons.save' | translate }}</ceres-button>
                    <ceres-button icon="close" [style]="'primary'" (click)="close()" type="button">{{
                        'shared.buttons.cancel' | translate
                    }}</ceres-button>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-6 mb-4 form-container">
                <div class="options-form options-form--header">
                    <div class="row">
                        <div class="col-12 mb-2">
                            <p>{{ 'shared.miscellaneous.general-information' | translate }}</p>
                        </div>
                    </div>
                </div>
                <div class="options-form">
                    <div class="row">
                        <div class="col-sm-6 mb-2">
                            <mat-form-field class="mat-custom" appearance="fill">
                                <mat-label>{{ 'bop.properties.number' | translate }}</mat-label>
                                <input matInput formControlName="bopNumber" required />
                            </mat-form-field>
                        </div>
                        <div class="col-sm-6 mb-2">
                            <mat-form-field class="mat-custom" appearance="fill">
                                <mat-label>{{ 'bop.properties.title' | translate }}</mat-label>
                                <input matInput formControlName="bopTitle" required />
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 mb-2">
                            <ceres-user-picker
                                (selected)="changeBopLeader($event)"
                                [appUser]="true"
                                [condition]="pickerCondition('bopLeader')"
                                [fullUser]="true"
                                [required]="true"
                                [value]="formGroup.value.bopLeader"
                                [noCheck]="true"
                                placeholder="{{ 'bop.properties.responsible' | translate }}"
                            >
                            </ceres-user-picker>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6 mb-3">
                            <mat-form-field class="mat-custom" appearance="fill">
                                <mat-label>{{ 'shared.properties.business-area' | translate }}</mat-label>
                                <mat-select [compareWith]="compareLookups" formControlName="businessArea" required>
                                    <mat-option>
                                        <ngx-mat-select-search
                                            [placeholderLabel]="'shared.miscellaneous.search-dots' | translate"
                                            [formControl]="businessAreasFilterCtrl"
                                            ><span ngxMatSelectNoEntriesFound>
                                                {{ 'shared.miscellaneous.no-entries-found' | translate }}
                                            </span></ngx-mat-select-search
                                        >
                                    </mat-option>
                                    @for (item of businessAreasOptions | async | orderBy: item; track item) {
                                        <mat-option [value]="item"
                                            >{{ item.longName ? item.longName : item.name }}
                                        </mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6 mb-2">
                            <mat-form-field class="mat-custom" appearance="fill">
                                <mat-label>{{
                                    'projects.project-detail.information.planned-project-start' | translate
                                }}</mat-label>
                                <input
                                    [matDatepicker]="startDate"
                                    formControlName="plannedProjectStart"
                                    matInput
                                    (ngModelChange)="recalculateDates(false)"
                                    [min]="fiscalYearStart"
                                    required
                                />
                                <mat-datepicker-toggle matSuffix [for]="startDate"></mat-datepicker-toggle>
                                <mat-datepicker #startDate></mat-datepicker>
                            </mat-form-field>
                            @if (startDateWarning) {
                                <span class="date-warning">{{ 'shared.properties.date-warning' | translate }}</span>
                            }
                        </div>
                        <div class="col-sm-6 mb-2">
                            <mat-form-field class="mat-custom" appearance="fill">
                                <mat-label>{{
                                    'projects.project-detail.information.planned-project-end' | translate
                                }}</mat-label>
                                <input
                                    [matDatepicker]="endDate"
                                    formControlName="plannedProjectEnd"
                                    matInput
                                    (ngModelChange)="recalculateDates(true)"
                                    [min]="fiscalYearStart"
                                    required
                                />
                                <mat-datepicker-toggle matSuffix [for]="endDate"></mat-datepicker-toggle>
                                <mat-datepicker #endDate></mat-datepicker>
                            </mat-form-field>
                            @if (endDateWarning) {
                                <span class="date-warning">{{ 'shared.properties.date-warning' | translate }}</span>
                            }
                        </div>
                    </div>
                    <div class="row mb-3">
                        @if (bopConfig.validateLabel('bop.planned-duration')) {
                            <div class="col-sm-6">
                                <mat-form-field class="mat-custom" appearance="fill">
                                    <mat-label>{{ 'bop.properties.planned-duration' | translate }}</mat-label>
                                    <input [value]="plannedProjectDuration" matInput readonly type="number" />
                                </mat-form-field>
                            </div>
                        }
                    </div>
                    <div class="row">
                        @if (bopConfig.validateLabel('bop.content')) {
                            <div class="col-12 mb-2">
                                <mat-form-field class="mat-custom" appearance="fill">
                                    <mat-label>{{ 'shared.miscellaneous.content' | translate }}</mat-label>
                                    <textarea formControlName="content" matInput type="text"></textarea>
                                </mat-form-field>
                            </div>
                        }
                    </div>
                </div>
                <div class="options-form options-form--header">
                    <div class="row">
                        <div class="col-12 mb-2">
                            <p>{{ 'businesspartner.general.title' | translate }}</p>
                        </div>
                    </div>
                </div>
                <div class="options-form">
                    <div class="row">
                        <div class="col-sm-6 mb-2">
                            <ceres-user-picker
                                (selected)="changeBusinessPartner($event)"
                                [appUser]="true"
                                [businessPartner]="true"
                                [condition]="pickerCondition('businessPartner')"
                                [required]="true"
                                [value]="formGroup.value.businessPartner"
                                [noCheck]="true"
                                placeholder="{{ 'businesspartner.general.title' | translate }}"
                            ></ceres-user-picker>
                        </div>
                        <div class="col-sm-6 mb-2">
                            <mat-form-field class="mat-custom" appearance="fill">
                                <mat-label>{{ 'businesspartner.properties.phone' | translate }}</mat-label>
                                <input [value]="formGroup.value.businessPartner?.phone || ''" disabled matInput />
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6 mb-2">
                            <mat-form-field class="mat-custom" appearance="fill">
                                <mat-label>{{ 'businesspartner.properties.company-name' | translate }}</mat-label>
                                <input
                                    [value]="
                                        formGroup.value.businessPartner?.companyNames?.length
                                            ? formGroup.value.businessPartner.companyNames[0].name
                                            : ''
                                    "
                                    disabled
                                    matInput
                                />
                            </mat-form-field>
                        </div>
                        <div class="col-sm-6 mb-2">
                            <mat-form-field class="mat-custom" appearance="fill">
                                <mat-label>{{ 'shared.properties.department' | translate }}</mat-label>
                                <input [value]="formGroup.value.businessPartner?.department || ''" disabled matInput />
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 form-container">
                <div class="options-form options-form--header">
                    <div class="row">
                        <div class="col-12 mb-2">
                            <p>{{ 'offers.properties.information' | translate }}</p>
                        </div>
                    </div>
                </div>
                <div class="options-form">
                    <div class="row">
                        @if (bopConfig.validateLabel('bop.offer-title')) {
                            <div class="col-sm-6 mb-2">
                                <mat-form-field class="mat-custom" appearance="fill">
                                    <mat-label>{{ 'offers.properties.title' | translate }}</mat-label>
                                    <input matInput formControlName="offerTitle" />
                                </mat-form-field>
                            </div>
                        }
                        @if (bopConfig.validateLabel('bop.offer-date')) {
                            <div class="col-sm-6 mb-2">
                                <mat-form-field class="mat-custom" appearance="fill">
                                    <mat-label>{{ 'offers.properties.date' | translate }}</mat-label>
                                    <input [matDatepicker]="offerDate" formControlName="offerDate" matInput />
                                    <mat-datepicker-toggle matSuffix [for]="offerDate"></mat-datepicker-toggle>
                                    <mat-datepicker #offerDate></mat-datepicker>
                                </mat-form-field>
                            </div>
                        }
                    </div>
                    <div class="row">
                        <div class="col-sm-6">
                            <mat-form-field class="mat-custom" appearance="fill">
                                <mat-label>{{ 'bop.properties.status' | translate }}</mat-label>
                                <mat-select formControlName="bopStatus" required>
                                    @for (item of bopStatus | translateOrder; track item) {
                                        <mat-option [value]="item">{{ item.translationKey | translate }}</mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-sm-6">
                            <mat-form-field class="mat-custom" appearance="fill">
                                <mat-label>{{ 'bop.properties.probability-class' | translate }}</mat-label>
                                <mat-select formControlName="probabilityClass" required>
                                    @for (item of probabilityClasses | translateOrder; track item) {
                                        <mat-option [value]="item">{{ item.translationKey | translate }} </mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6 mb-3">
                            <mat-form-field class="mat-custom" appearance="fill">
                                <mat-label>{{ 'bop.properties.declined-reason.title' | translate }}</mat-label>
                                <mat-select
                                    [required]="formGroup.value.bopStatus === 3"
                                    formControlName="declineReason"
                                >
                                    @for (item of declineReasons | translateOrder; track item) {
                                        <mat-option [value]="item">{{ item.translationKey | translate }} </mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 mb-2">
                            <mat-form-field class="mat-custom" appearance="fill">
                                <mat-label>{{ 'bop.properties.decline-comment' | translate }}</mat-label>
                                <textarea formControlName="declineComment" matInput type="text"></textarea>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
                <div class="options-form options-form--header">
                    <div class="row">
                        <div class="col-12 mb-2">
                            <p>{{ 'bop.properties.volume' | translate }}</p>
                        </div>
                    </div>
                </div>
                <div class="options-form">
                    <div class="row">
                        @if (bopConfig.validateLabel('bop.charging-volume-own')) {
                            <div class="col-sm-6 mb-2">
                                <mat-form-field class="mat-custom" appearance="fill">
                                    <mat-label>{{ 'bop.properties.charging-volume-own' | translate }}</mat-label>
                                    <input
                                        formControlName="chargeVolumeOwn"
                                        matInput
                                        min="0"
                                        oninput="validity.valid || (value = value.replace(/[^\d.,]/g, ''))"
                                        type="number"
                                    />
                                </mat-form-field>
                            </div>
                        }
                        @if (bopConfig.validateLabel('bop.charging-volume-others')) {
                            <div class="col-sm-6 mb-2">
                                <mat-form-field class="mat-custom" appearance="fill">
                                    <mat-label>{{ 'bop.properties.charging-volume-others' | translate }}</mat-label>
                                    <input
                                        formControlName="chargeVolumeOthers"
                                        matInput
                                        min="0"
                                        oninput="validity.valid || (value = value.replace(/[^\d.,]/g, ''))"
                                        type="number"
                                    />
                                </mat-form-field>
                            </div>
                        }
                    </div>
                    <div class="row">
                        @if (bopConfig.validateLabel('bop.material-costs')) {
                            <div class="col-sm-6 mb-2">
                                <mat-form-field class="mat-custom" appearance="fill">
                                    <mat-label>{{ 'bop.properties.material-costs' | translate }}</mat-label>
                                    <input
                                        formControlName="materialCosts"
                                        matInput
                                        type="number"
                                        matTooltip="{{ 'bop.tooltips.material-cost' | translate }}"
                                        matTooltipClass="pwo-tooltip"
                                    />
                                </mat-form-field>
                            </div>
                        }
                        @if (bopConfig.validateLabel('bop.total-volume')) {
                            <div class="col-sm-6 mb-2">
                                <mat-form-field class="mat-custom" appearance="fill">
                                    <mat-label>{{ 'bop.properties.total-volume-in-euro' | translate }}</mat-label>
                                    <input [value]="totalVolume | number: '1.2-2' : 'de'" matInput readonly />
                                </mat-form-field>
                            </div>
                        }
                    </div>
                    <div class="row">
                        @if (bopConfig.validateLabel('bop.total-probability')) {
                            <div class="col-sm-6 mb-2">
                                <mat-form-field class="mat-custom" appearance="fill">
                                    <mat-label>{{ 'bop.properties.total-probability' | translate }}</mat-label>
                                    <input [value]="totalProbability" matInput readonly type="number" />
                                </mat-form-field>
                            </div>
                        }
                        @if (bopConfig.validateLabel('bop.expected-value')) {
                            <div class="col-sm-6 mb-2">
                                <mat-form-field class="mat-custom" appearance="fill">
                                    <mat-label>{{ 'bop.properties.expected-value' | translate }}</mat-label>
                                    <input [value]="expectedValue | number: '1.2-2' : 'de'" matInput readonly />
                                </mat-form-field>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    </form>
}
@if (!formGroup) {
    <ceres-loading></ceres-loading>
}
